import { FeatureVisibility, IFeature } from '@principle-theorem/feature-flags';

export const PRACTICE_STAFFER_FEE_SCHEDULES_FEATURE: IFeature = {
  label: 'practice-staffer-fee-schedules',
  visibility: FeatureVisibility.OptIn,
  permissions: [],
};
